import { useEffect, useRef, useState } from 'react'
import { useClickOutside } from 'src/utils/useClickOutside'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { useAddressContext } from 'src/components/checkout/steps/shipping/context/address-context'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import { getCookie, setCookie } from 'src/utils/cookies'

export const PostalCodeReminder = ({ showModal }: { showModal: boolean }) => {
  const [showReminder, setShowReminder] = useState(false)
  const { postalCode } = useAddressContext()
  const selectRef = useRef<HTMLDivElement>(null)
  const { pageData } = useGlobalContext()

  const onDismiss = ({ isButtonClick }: { isButtonClick: boolean }) => {
    setShowReminder(false)

    setCookie('isPostalCodeDismissed', 'true', {
      expiresInMinutes: 24 * 60, // Expires in 1 day
    })

    if (!isButtonClick) {
      return
    }

    dispatchAmplitudeEvent({
      eventName: 'Click Button Modal',
      eventData: {
        ...getStandardObject(pageData),
        'modal nome': 'Confira as melhores ofertas e fretes para sua região!',
        'modal botao nome': 'Mais tarde',
      },
    })

    dispatchAmplitudeEvent({
      eventName: 'CEP Modal Closed Without Entry',
      eventData: {
        ...getStandardObject(pageData),
        'modal nome': 'Confira as melhores ofertas e fretes para sua região!',
        'modal botao nome': 'Mais tarde',
      },
    })
  }

  useEffect(() => {
    const isPostalCodeDismissed = getCookie('isPostalCodeDismissed')

    if (isPostalCodeDismissed || !!postalCode || showModal) {
      return
    }

    setShowReminder(true)
  }, [postalCode, showModal])

  useClickOutside(selectRef, () => onDismiss({ isButtonClick: false }))

  if (!showReminder) {
    return null
  }

  return (
    <>
      <div
        ref={selectRef}
        className="flex justify-start flex-col gap-3 absolute font-medium shadow-dropCard bg-postal-page rounded-lg w-[273px] p-4 mt-2 sm:mt-4 ml-4 sm:-ml-2 z-10 before:content-[''] before:absolute before:w-4 before:h-4 before:bg-postal-page before:rounded-sm before:top-[-5px] before:left-[25px] before:-rotate-45"
      >
        <span className="text-base">
          Confira as{' '}
          <span className="text-postal-accent">melhores ofertas</span> e fretes
          para sua região!
        </span>

        <button
          className="flex text-sm text-postal-secondary underline"
          onClick={() => onDismiss({ isButtonClick: true })}
        >
          Mais tarde
        </button>
      </div>
    </>
  )
}
